export default "__VITE_ASSET__aaf48519__"